import axios from 'axios';
import { toast } from 'react-toastify';
import {
  EVENTS_DELETE_ACTION_BEGIN,
  EVENTS_DELETE_ACTION_SUCCESS,
  EVENTS_DELETE_ACTION_FAILURE,
  EVENTS_DELETE_ACTION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteAction(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_DELETE_ACTION_BEGIN,
    });
    const { projectId, eventId, actionId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events/${eventId}/actions/${actionId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: EVENTS_DELETE_ACTION_SUCCESS,
              data: res.data,
              eventId: args.eventId,
            });
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EVENTS_DELETE_ACTION_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EVENTS_DELETE_ACTION_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteActionError() {
  return {
    type: EVENTS_DELETE_ACTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_DELETE_ACTION_BEGIN:
      return {
        ...state,
        deleteActionPending: true,
        deleteActionError: null,
      };

    case EVENTS_DELETE_ACTION_SUCCESS:
      // The request is success
      let events = state.events;
      let index = events.findIndex((item) => {
        return item.uuid === action.eventId;
      });
      events[index] = action.data;
      return {
        ...state,
        deleteActionPending: false,
        deleteActionError: null,
        events: events,
        selectedEvent: {
          ...state.selectedEvent,
          actions: action.data,
        },
      };

    case EVENTS_DELETE_ACTION_FAILURE:
      return {
        ...state,
        deleteActionPending: false,
        deleteActionError: action.data.error,
      };

    case EVENTS_DELETE_ACTION_DISMISS_ERROR:
      return {
        ...state,
        deleteActionError: null,
      };

    default:
      return state;
  }
}
